import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { getLogonInfoFromCookies, saveLogonInfoToCookies } from "../utils/util";
import { Box } from "@vapor/v3-components";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { TextEyePassword } from "../components/TextEyePassword";
import {
  Button,
  TextField,
  VaporThemeProvider,
  VaporPage,
  Typography,
  Checkbox,
  NotificationOverflow,
  AlertTitle,
  IconButton,
  FormControlLabel,
  VaporIcon,
  FullscreenSpinner,
  Drawer,
  Title,
  VaporToolbar,
  Spinner,
  Toast,
  NotificationInline,
  Stack,
} from "@vapor/v3-components";
import {
  login,
  verifyToken,
  sendPasswordRecovery,
} from "../services/authService";
import { getSiteParameters } from "../services/siteParametersService";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { usePersistentState } from "../store/usePersistentState";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import {
  AuthResponse,
  VerifyTokenResponse,
  RecoverPasswordResponse,
} from "../services/Models/AuthModel";
import { ChangePassword } from "../components/ChangePassword";
import { FilterListResponse } from "../services/Models/FilterListModel";
import { getFilterList } from "../services/filterListService";
import { localFilter } from "./Home";
import { CmsFilterDescriptorBase } from "../services/Models/FilterDescriptorModel";
import { useAuth } from "../Router/AuthProvider";
import { returnError } from "../utils/util";
import util from "../utils/util";
import i18next from "i18next";

const LoginPage: React.FC = () => {
  const { logout } = useParams();
  const { performLogout, performLogin, isAuthenticated, redirectPath } =
    useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const [errorDescription, setErrorDescription] = useState<string | null>(searchParams.get("error_description"));
  const { t } = useTranslation();

  // const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(
    searchParams.get("error_description")
  );
  const [image, setImage] = usePersistentState("image", "");
  const [loading, setLoading] = useState(true);
  const [loadingLostPwd, setLoadingLostPwd] = useState(false);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [parametersLoaded, setparametersLoaded] = useState(false);
  const passwordInputRef = useRef<HTMLInputElement>(null); // Referenza per spostarsi al campo password

  const [rememberMe, setRememberMe] = useState(false);
  const [showLostPwd, setShowLostPwd] = useState(false);
  const [activeSend, setActiveSend] = useState(false);
  const [saveOKLostPwd, setSaveOKLostPwd] = useState(false);
  const [passwordExpired, setPasswordExpired] = useState<boolean>(false);
  const [recoveryEMail, setRecoveryEMail] = useState("");
  const [errorMail, setErrorMail] = useState<string | null>(null);
  const [errorLostPwd, setErrorLostPwd] = useState<string | null>(null);
  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Funzione di validazione
  const isValidEmail = (email: string): boolean => {
    const validMail = email === "" ? true : emailRegex.test(email);
    setErrorMail(validMail ? null : t("wrong-e-mail"));
    return validMail;
  };

  const handleOnChangeEmail = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setRecoveryEMail(e.target.value);
    if (e.target.value !== "") setActiveSend(true);
    else setActiveSend(false);
    isValidEmail(e.target.value);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRememberMe(event.target.checked); // Aggiorna lo stato con il valore del checkbox
  };

  const loadFilters = async (
    loginResult: AuthResponse,
    contPubFiltro: boolean
  ) => {
    try {
      const result: FilterListResponse = await getFilterList(
        loginResult.SecurityToken,
        loginResult.Language ?? "it",
        contPubFiltro
      );
      if (result && result.ResultCode !== "ERROR") {
        console.log("getFilter successful:");
        const locFilters: localFilter[] = result.Filters.map(
          (filter: CmsFilterDescriptorBase) => {
            const appFilter: localFilter = {
              filterId: filter.FilterId,
              filterName: filter.FilterName,
              IconFile: filter.IconFile,
              TotPub: filter.TotPub,
              LinkedDocs: filter.LinkedDocs === "1" ? true : false,
              noDownloadVideo:
                filter.DownloadVideo === "nodownload" ? true : false,
            };
            return appFilter;
          }
        );
        localStorage.setItem("filterList", JSON.stringify(locFilters));
        if (locFilters.length === 0) setError(t("noEnabledFilters"));
        else {
          if (redirectPath) {
            performLogin(redirectPath);
          } else {
            navigate(`/filter/${locFilters[0].filterId}`);
          }
        }
      } else {
        setError(t(returnError(result)));
        console.error("loadFilters Error :", "no result");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("loadFilters Error :", error);
    } finally {
      setLoadingFetch(false);
    }
  };

  const loadSiteParameter = async () => {
    setLoading(true);
    setLoadingFetch(true);
    try {
      setError(null);
      const result: SiteParametersResponse = await getSiteParameters(null);
      if (result) {
        if (result.ResultCode === "ERROR") {
          setError(result.DetailedMessage);
          console.error("getSiteParameters failed:", result.DetailedMessage);
        } else {
          localSiteParameters.current = result;
          // localStorage.setItem("SiteParameters", JSON.stringify(result));
          if (localSiteParameters.current.UserAutoLogin !== "") {
            await handleLogin(localSiteParameters.current.UserAutoLogin);
          }
          const localLogin = getLogonInfoFromCookies();
          if (localLogin && localLogin.rememberMe && localLogin.SecurityToken) {
            const resultVerify: VerifyTokenResponse = await verifyToken(
              localLogin.SecurityToken,
              false
            );
            if (resultVerify.ResultCode !== "ERROR") {
              performLogin();
              switch (result.Visualizzazione) {
                case "continuo":
                  navigate("/presentationPage");
                  break;
                case "tabs":
                  loadFilters(localLogin, result.ContPubFiltro);
                  break;
                default:
                  navigate("/home");
              }
            }
          }
          if (localSiteParameters.current.SSOObbligatoria) handleLoginSSO();
          console.log("getSiteParameters successful:");
        }
      } else {
        setError(t("errore interno"));
        console.error("getSiteParameters failed:", "no response");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("getSiteParameters failed:", error);
    } finally {
      setLoadingFetch(false);
      setLoading(false);
      setparametersLoaded(true);
    }
  };

  // useEffect(() => {
  //   loadSiteParameter();
  // }, []);

  useEffect(() => {
    loadSiteParameter();
  }, [logout]);

  const handleEnterPress = (
    event: React.KeyboardEvent<HTMLDivElement>,
    nextFieldRef?: React.RefObject<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Previene il comportamento predefinito
      if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus(); // Sposta il focus al campo successivo
      } else {
        handleLogin(); // Se non c'è un riferimento, esegue la funzione di login
      }
    }
  };

  const send_PasswordRecovery = async () => {
    try {
      setLoadingLostPwd(true);
      setErrorLostPwd(null);
      const result: RecoverPasswordResponse = await sendPasswordRecovery(
        recoveryEMail
      );
      if (result.ResultCode === "ERROR") {
        setErrorLostPwd(result.DetailedMessage);
        console.error("sendPasswordrecovery failed: ", result.DetailedMessage);
      } else {
        setSaveOKLostPwd(true);
        console.log("sendPasswordrecovery successful: ", recoveryEMail);
      }
      // Gestire la navigazione o il salvataggio del token
    } catch (error) {
      setErrorLostPwd(t("errore interno"));
    } finally {
      setLoadingLostPwd(false);
    }
  };

  const handleLogin = async (userAutoLogin?: string) => {
    try {
      setError(null);
      setLoadingFetch(true);
      let result: AuthResponse = await login(
        userAutoLogin ?? username,
        userAutoLogin ? null : password,
        0,
        null,
        true
      );
      if (result.ResultCode === "ERROR") {
        if (result.MessageNumber === 20102) {
          setPasswordExpired(true);
        } else {
          setError(result.DetailedMessage);
          // dispatch(resetUser());
          setImage("");
          console.error("Login failed:", result.DetailedMessage);
        }
      } else {
        if (!result.Language) result = { ...result, Language: "it" };
        else if (result.Language === "") result.Language = "it";
        saveLogonInfoToCookies({ ...result, rememberMe: rememberMe });
        localStorage.setItem("filterList", JSON.stringify([]));
        //        dispatch(setUser({ image: result.Image, userName: result.UserLogin }));
        setImage(window.config.BASE_URL + "/preview/" + result.Image);

        if (i18next.language !== result.Language) {
          await i18next
            .changeLanguage(result.Language)
            .then(() => {
              i18next
                .reloadResources()
                .then(() => {
                  console.log("Risorse ricaricate:", i18next.language);
                })
                .catch((error) => {
                  console.error("Errore nel cambio lingua:", error);
                });
            })
            .catch((error) => {
              console.error("Errore nel cambio lingua:", error);
            });
        }

        console.log("Login successful:", result.UserLogin);
        if (redirectPath) {
          await loadFilters(result, localSiteParameters.current.ContPubFiltro);
        } else {
          performLogin();
          switch (localSiteParameters.current.Visualizzazione) {
            case "continuo":
              navigate("/presentationPage");
              break;
            case "tabs":
              await loadFilters(
                result,
                localSiteParameters.current.ContPubFiltro
              );
              break;
            default:
              navigate("/home");
          }
        }
      }
      // Gestire la navigazione o il salvataggio del token
    } catch (error) {
      setError(t("errore interno"));
      // dispatch(resetUser());
      setImage("");
      console.error("Login failed:", error);
    } finally {
      setLoadingFetch(false);
    }
  };

  const handleLoginSSO = async () => {
    try {
      setError(null);
      const result: AuthResponse = await login(username, password, -1);
      if (result.ResultCode === "ERROR") {
        setError(result.DetailedMessage);
      }
      window.location.href = result.SecurityToken; // Redirige al provider OAuth2
      // Gestire la navigazione o il salvataggio del token
    } catch (error) {
      console.error("Login failed:", error);
      setError("Credenziali non valide o errore del server");
    }
  };

  const recoveryPwd = () => {
    return (
      <Drawer anchor="right" hideBackdrop width={800} open={showLostPwd}>
        <Title
          divider
          rightItems={[
            <IconButton
              color="primary"
              onClick={() => {
                setShowLostPwd(false);
              }}
              variant="text"
            >
              <VaporIcon icon={faXmark} size="s" color="primary" />
            </IconButton>,
          ]}
          title={t("recovery-password")}
        />
        <Box padding={2} margin={2}>
          <TextField
            variant="outlined"
            label={t("home-user-mail")}
            id="eMail"
            style={{
              width: 400,
              marginTop: 32,
            }}
            value={recoveryEMail}
            onChange={(e) => handleOnChangeEmail(e)}
            error={errorMail ? true : false}
            helperText={errorMail}
          />
        </Box>
        <VaporToolbar
          contentRight={[
            <Button
              variant="outlined"
              onClick={() => {
                setShowLostPwd(false);
              }}
            >
              {t("cancel")}
            </Button>,
            <Button
              variant="contained"
              onClick={() => {
                send_PasswordRecovery();
              }}
              disabled={!activeSend || errorMail !== null}
            >
              {t("do-send")}
            </Button>,
          ]}
          size="medium"
          variant="regular"
          withoutAppBar
        />
        {loadingLostPwd && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
        {errorLostPwd && (
          <NotificationOverflow
            severity="error"
            onClose={() => setErrorLostPwd(null)}
          >
            <AlertTitle>{t("error-header")}</AlertTitle>
            {errorLostPwd}
          </NotificationOverflow>
        )}
        <Toast
          open={saveOKLostPwd}
          anchorOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          // autoHideDuration={2000}
          onClose={() => {
            setSaveOKLostPwd(false);
            setShowLostPwd(false);
          }}
        >
          <NotificationInline
            severity="success"
            onClose={() => {
              setSaveOKLostPwd(false);
              setShowLostPwd(false);
            }}
          >
            <AlertTitle>{t("recovery-password")}</AlertTitle>
            {t("sendRecoveryPwd")}
            <Stack
              direction="row"
              spacing={2}
              sx={{
                mt: 3,
              }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  setSaveOKLostPwd(false);
                  setShowLostPwd(false);
                }}
              >
                {t("close")}
              </Button>
            </Stack>
          </NotificationInline>
        </Toast>
      </Drawer>
    );
  };

  if (loading) return <FullscreenSpinner size={64} />;

  return (
    <VaporThemeProvider>
      <VaporPage>
        {parametersLoaded && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#f5f5f5",
              flexDirection: "column",
            }}
          >
            <img
              alt="example"
              src={window.config.BASE_URL + window.config.LOGO_CMS}
              style={{
                maxWidth: "500px",
                maxHeight: "500px",
                minWidth: "100px",
                minHeight: "20px",
                marginBottom: "20px",
                objectFit: "contain",
              }}
            />

            <Box
              sx={{
                width: "100%",
                maxWidth: 800,
                height: "100%",
                maxHeight: 580,
                minWidth: 100,
                minHeight: 100,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: 2,
                backgroundColor: "white",
                boxShadow: 3,
                borderRadius: 2,
              }}
            >
              <Typography
                variant="headingsSubtitle"
                gutterBottom
                color="contentInformative"
                align="center"
              >
                {t("service-logon")}
              </Typography>
              <Typography
                variant="bodyHelperRegular"
                gutterBottom
                color="contentInformative"
                align="center"
              >
                {t("sso-info1")}
              </Typography>
              <Typography
                variant="bodyHelperRegular"
                gutterBottom
                color="contentInformative"
                align="center"
              >
                {t("sso-info2")}
              </Typography>
              <Typography
                variant="bodyHelperRegular"
                gutterBottom
                color="contentInformative"
                align="center"
              >
                {t("sso-info3")}
              </Typography>
              <Typography
                variant="bodyHelperRegular"
                gutterBottom
                color="contentDecorative"
                align="center"
              >
                {t("user-accedicon")}
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                sx={{ flexShrink: 0 }}
                onClick={handleLoginSSO}
                size="medium"
              >
                {t("do-login-tsid")}
              </Button>
              <Typography
                variant="bodyHelperRegular"
                gutterBottom
                color="contentDecorative"
                align="center"
              >
                {t("user-oppure")}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                label={t("user-name-key")}
                id="user"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e, passwordInputRef)} // Premendo Enter va al campo successivo
                autoFocus
                sx={{
                  flexShrink: 0,
                  "& input:-webkit-autofill": {
                    boxShadow: "0 0 0 100px white inset",
                    WebkitTextFillColor: "#000",
                  },
                }}
              />
              <TextEyePassword
                fullWidth
                variant="outlined"
                id="password"
                label={t("password-key")}
                inputRef={passwordInputRef} // Riferimento per lo spostamento del focus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e)} // Corretto evento
                sx={{
                  "& input:-webkit-autofill": {
                    boxShadow: "0 0 0 100px white inset",
                    WebkitTextFillColor: "#000",
                  },
                }}
              />
              {/* <FormControl>
              <TextField
                fullWidth
                variant="outlined"
                id="password"
                inputRef={passwordInputRef} // Riferimento per lo spostamento del focus
                type={showPassword ? "text" : "password"}
                sx={{ flexShrink: 0 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e)} // Corretto evento
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ margin: 0, padding: 0 }}
                    >
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(e) => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ padding: 0 }}
                        variant="text"
                      >
                        {showPassword ? (
                          <VaporIcon icon={faEye} size="s" />
                        ) : (
                          <VaporIcon icon={faEyeSlash} size="s" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                label={t("password-key")}
              />
            </FormControl> */}
              <FormControlLabel
                control={
                  <Checkbox checked={rememberMe} onChange={handleChange} />
                }
                label={t("keep-logon-active")}
                labelPlacement="end"
                value="right"
                sx={{
                  padding: "0px 6px",
                }}
              />

              <Button
                fullWidth
                variant="contained"
                color="primary"
                sx={{ flexShrink: 0 }}
                onClick={() => handleLogin()}
                size="medium"
              >
                {t("do-logon")}
              </Button>
              <Button
                onClick={() => setShowLostPwd(true)}
                size="small"
                sx={{
                  fontSize: "12px",
                  padding: "4px 0px",
                  alignSelf: "flex-start",
                }}
              >
                {t("Password dimenticata?")}
              </Button>
              {error && (
                <NotificationOverflow
                  severity="error"
                  onClose={() => setError(null)}
                >
                  <AlertTitle>{t("error-header")}</AlertTitle>
                  {error}
                </NotificationOverflow>
              )}
            </Box>
          </Box>
        )}
        {recoveryPwd()}
        <ChangePassword
          title={t("password-expired")}
          open={passwordExpired}
          onClose={() => {
            setPasswordExpired(false);
          }}
          passwordExpired={true}
          userName={username}
        />
        {loadingFetch && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
      </VaporPage>
    </VaporThemeProvider>
  );
};

export default LoginPage;
